export enum UnitsOfMeasurementEnum {
    metric = 0,
    imperial = 1,
}
